<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_x"></a><a id="page_xi"></a><a id="not"></a>NOTE ON TRANSLATION</h2>
<p class="noindent">All translations are mine, unless otherwise noted. Cities in the multi-ethnic Austrian empire and its successors almost always had a German name as well as a second version, as in Lemberg/Lwów. Depending on the time and the circumstances, I have tried to use the German name or the Slavic one, following Hugo Huppert’s usage, which usually favors the German name he grew up with, as in Teschen and Bielitz.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// not.vue?db2198d6